export default "__VITE_ASSET__BCiu9fmE__"